import { Link } from "react-router-dom";
import { SiteHeader } from "../components/SiteHeader";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-slate-50/40">
      <SiteHeader />
      <main className="max-w-md mx-auto px-6 py-20" data-testid="payment-cancel-main">
        <Card className="border-slate-200 p-8 text-center">
          <div className="w-14 h-14 rounded-full bg-slate-100 mx-auto mb-4 flex items-center justify-center">
            <XCircle className="w-7 h-7 text-slate-500" />
          </div>
          <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900 mb-2">
            Payment cancelled
          </h1>
          <p className="text-sm text-slate-600 mb-6">
            No charge was made. You can try again any time.
          </p>
          <Link to="/">
            <Button className="w-full bg-[#065F46] hover:bg-[#047857] text-white">
              Back home
            </Button>
          </Link>
        </Card>
      </main>
    </div>
  );
}
